import { ACTION_STATES } from "core/actions";
import { assertString } from "core/validation";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import ErrorDialog from "./ErrorDialog";
import LoadingFullScreen from "./LoadingFullScreen";

function showSuccessToaster(message) {
    toast.info(message, {
        position: "top-right",
    });
}

function StatusHandler({ status = ACTION_STATES.NO_REQUEST, error, onClose, showLoading = false, loadingMessage = "Loading...", successMessage }) {
    const [showDialog, setShowDialog] = React.useState(false);
    const [actionState, setActionState] = React.useState(ACTION_STATES.NO_REQUEST);
    const handleClose = () => {
        setShowDialog(false);
        if (onClose) {
            onClose();
        }
    };

    useEffect(() => {
        if (status !== actionState) {
            if (status === ACTION_STATES.FAILED && !showDialog) {
                setShowDialog(true);
            } else if (status === ACTION_STATES.SEND && !showDialog && showLoading) {
                setShowDialog(true);
            } else if (
                status === ACTION_STATES.SUCCESS &&
                actionState !== ACTION_STATES.SUCCESS &&
                showDialog &&
                assertString(successMessage)
            ) {
                showSuccessToaster(successMessage);
            }
            setActionState(status);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status]);

    const isLoading = status === ACTION_STATES.SEND;
    const isError = status === ACTION_STATES.FAILED;

    let content = null;

    if (isLoading && showLoading && showDialog) {
        content = <LoadingFullScreen open={true} loadingMessage={loadingMessage} />;
    } else if (showDialog && isError) {
        let msg = {};
        if (error) {
            const { serverMessage, details, message, title } = error;
            const dtl = serverMessage ? serverMessage + " " + details : details;
            msg = {
                title: title,
                message: message,
                details: dtl,
            };
        }

        content = <ErrorDialog {...msg} defaultOpen={true} onClose={handleClose} />;
    }
    return content;
}

StatusHandler.propTypes = {
    error: PropTypes.any,
    onClose: PropTypes.func,
    showLoading: PropTypes.bool,
    status: PropTypes.any.isRequired,
};


export default StatusHandler;
